var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.page === 'login')?_c('Login',{attrs:{"error":_vm.error}}):_vm._e(),(_vm.page === 'card')?_c('Card'):_vm._e(),(_vm.page === 'list')?_c('List',{attrs:{"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }